import React, {useRef} from 'react';
import {i18n} from '@netx/core/i18n';
import {faUsersMedical} from '@netx/core-icons';
import {
	LegacyFormDialog as Dialog,
	type LegacyExtendFormDialogProps,
} from '@netx/core-components/FormDialog';
import {dialogClasses} from '@netx/core-components/Dialog';
import {styled} from '@netx/core-components/Theme';
import {PERMISSION_TITLES} from '../../locales';
import PermissionFormBody, {type PermissionsFormProps} from '../FormBody';

const PermissionsDialogRoot = styled(Dialog)(({theme}) => ({
	[`& .${dialogClasses.content}`]: {
		overflow: 'hidden',
	},
}));

export type PermissionsDialogProps = Omit<
	PermissionsFormProps,
	'classes' | 'columns' | 'onResize'
> &
	Omit<LegacyExtendFormDialogProps, 'classes'>;

const PermissionsDialogPrimitive = ({
	open,
	DialogProps,
	onClose,
	onSubmit,
	...props
}: PermissionsDialogProps) => {
	const backdropRef = useRef<HTMLDivElement>(null);
	return (
		<PermissionsDialogRoot
			confirmLabel={i18n.t('i18n.save')}
			disableContentPadding
			fullWidth
			icon={faUsersMedical}
			isValid={true}
			maxWidth="sm"
			preventBackdropClose
			{...DialogProps}
			onClose={onClose}
			onSubmit={onSubmit}
			open={open}
			requiresChanges
			secondaryTitle={props.attributeTemplate?.name || '...'}
			title={PERMISSION_TITLES.EDIT}
			BackdropProps={{
				ref: backdropRef,
			}}
		>
			<PermissionFormBody
				{...props}
				containerRef={backdropRef}
				onClose={() => {
					onClose?.();
				}}
			/>
		</PermissionsDialogRoot>
	);
};

export const PermissionsDialog = PermissionsDialogPrimitive;

export default PermissionsDialogPrimitive;
